import React from "react";
import { Reveal, SectionOverline } from "./Shared";

const Problem = () => {
  return (
    <section
      id="the-problem"
      data-testid="problem-section"
      className="relative py-32 sm:py-40 forr-canvas-alt"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-4">
            <Reveal>
              <SectionOverline number="01" label="The Problem" testId="problem-overline" />
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-8">
            <Reveal delay={0.05}>
              <h2
                data-testid="problem-heading"
                className="font-display forr-text-ink text-4xl sm:text-5xl md:text-6xl font-medium tracking-[-0.02em] leading-[1.05]"
              >
                Behavior isn’t a choice you make.
                <span className="forr-text-mute">
                  {" "}
                  It’s a state your body is already in.
                </span>
              </h2>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="mt-16 grid sm:grid-cols-2 gap-10 max-w-3xl">
                <p className="text-lg font-light forr-text-soft leading-relaxed">
                  You’ve tried the plan. The app. The routine. And it worked — until
                  the exact moment your body decided otherwise.
                </p>
                <p className="text-lg font-light forr-text-soft leading-relaxed">
                  That wasn’t failure. That was your nervous system executing a
                  physiological pattern it has practiced thousands of times.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.25}>
              <div className="mt-20 forr-divider" />
              <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-14">
                <div>
                  <div
                    data-testid="problem-stat-1-value"
                    className="font-display text-5xl forr-text-ink font-medium"
                  >
                    ~80<span className="forr-text-teal-deep">%</span>
                  </div>
                  <div className="mt-2 text-sm forr-text-mute max-w-[240px]">
                    of behavior change attempts are not sustained beyond 12 months in
                    published research.
                  </div>
                </div>
                <div>
                  <div
                    data-testid="problem-stat-2-value"
                    className="font-display text-5xl forr-text-ink font-medium"
                  >
                    Seconds
                  </div>
                  <div className="mt-2 text-sm forr-text-mute max-w-[240px]">
                    is often all the autonomic nervous system needs to precede
                    conscious intent.
                  </div>
                </div>
                <div>
                  <div
                    data-testid="problem-stat-3-value"
                    className="font-display text-5xl forr-text-ink font-medium"
                  >
                    Few
                  </div>
                  <div className="mt-2 text-sm forr-text-mute max-w-[240px]">
                    traditional approaches directly target the physiological state
                    driving behavior.
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;
